// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }`, "",{"version":3,"sources":["webpack://./src/containers/partnerDetails/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;EAChC","sourcesContent":[".grid-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
